import React, { useEffect } from 'react';
import $ from 'jquery';

const initComponent = (FlexApiRequest = window.FlexApiRequest) => {
    function Footer() {
        const containerId = 'manheim-footer__container';

        useEffect(() => {
            FlexApiRequest.POST({
                path: '/api/v1/auth/getpayoffsettings'
            })
                .send({})
                .then((response) => {
                    const { footerUri } = response.data;

                    if (footerUri) {
                        $(`#${containerId}`).load(footerUri);
                    }
                });
        }, []);

        return <mcom-footer></mcom-footer>;
    }

    return Footer;
};

module.exports = initComponent;
